export const CLASSIFICATION_IA_RUBRIC_CODE = 'CLASSIFICATION_IA';
